// import React from 'react';
// import { motion } from 'motion/react';
// import { useInView } from 'react-intersection-observer';
// import { Link2, Target, Zap, RefreshCw, Sparkles, Smartphone } from 'lucide-react';

// const features = [
//   {
//     icon: Link2,
//     title: 'Seamless Social Media Integration',
//     description: 'Smart cards link instantly to platforms like LinkedIn, Twitter, Instagram, enabling smooth transitions from in-person meetings to online connections.',
//     color: 'from-blue-500 to-cyan-500',
//   },
//   {
//     icon: Target,
//     title: 'Customized Sharing Options',
//     description: 'Choose platforms based on your profession: Creatives → Instagram/Pinterest, Corporate → LinkedIn',
//     color: 'from-purple-500 to-pink-500',
//   },
//   {
//     icon: Zap,
//     title: 'Simplified Connection Process',
//     description: 'One tap replaces searching names or usernames — no more missed connections or spelling errors.',
//     color: 'from-yellow-500 to-orange-500',
//   },
//   {
//     icon: RefreshCw,
//     title: 'Dynamic Content Delivery',
//     description: 'Share live content such as recent posts, portfolio updates, and achievements in real-time.',
//     color: 'from-green-500 to-emerald-500',
//   },
//   {
//     icon: Sparkles,
//     title: 'Tech-Savvy Professional Image',
//     description: 'Using smart cards shows innovation and forward-thinking professionalism.',
//     color: 'from-indigo-500 to-purple-500',
//   },
//   {
//     icon: Smartphone,
//     title: 'Adapting to Digital-First Networking',
//     description: 'Perfect for modern, tech-savvy professionals embracing digital networking trends.',
//     color: 'from-pink-500 to-rose-500',
//   },
// ];

// export function SocialMediaSynergy() {
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.1,
//   });

//   return (
//     <section className="py-20 lg:py-32 px-4 sm:px-6 lg:px-20 relative overflow-hidden">
//       {/* Background */}
//       <div className="absolute inset-0 bg-gradient-to-b from-transparent via-accent/5 to-transparent dark:via-accent/10" />
      
//       <div className="max-w-7xl mx-auto relative">
//         {/* Title */}
//         <motion.div
//           ref={ref}
//           initial={{ opacity: 0, y: 30 }}
//           animate={inView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.6 }}
//           className="text-center mb-16"
//         >
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             animate={inView ? { opacity: 1, scale: 1 } : {}}
//             transition={{ delay: 0.2 }}
//             className="inline-block mb-4"
//           >
//             <div className="px-6 py-2 bg-gradient-to-r from-primary/10 to-accent/10 rounded-full border border-primary/20">
//               <span className="text-sm font-semibold text-primary uppercase tracking-wider">
//                 Building Online Connections
//               </span>
//             </div>
//           </motion.div>
          
//           <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
//             Smart Cards &{' '}
//             <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
//               Social Media Synergy
//             </span>
//           </h2>
//           <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
//             Transform how you connect by seamlessly bridging physical and digital networking
//           </p>
//         </motion.div>

//         {/* Feature Grid */}
//         <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
//           {features.map((feature, index) => (
//             <motion.div
//               key={feature.title}
//               initial={{ opacity: 0, y: 40 }}
//               animate={inView ? { opacity: 1, y: 0 } : {}}
//               transition={{ delay: index * 0.1 + 0.3, duration: 0.6 }}
//               whileHover={{ y: -8, scale: 1.02 }}
//               className="group relative"
//             >
//               <div className="relative bg-card border border-border rounded-2xl p-6 lg:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 h-full">
//                 {/* Gradient Border on Hover */}
//                 <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-primary/0 to-accent/0 group-hover:from-primary/10 group-hover:to-accent/10 transition-all duration-300" />
                
//                 <div className="relative">
//                   {/* Icon */}
//                   <motion.div
//                     className={`w-14 h-14 rounded-xl bg-gradient-to-br ${feature.color} p-3 mb-4 shadow-lg`}
//                     whileHover={{ scale: 1.1, rotate: 5 }}
//                     transition={{ type: 'spring', stiffness: 300 }}
//                   >
//                     <feature.icon className="w-full h-full text-white" />
//                   </motion.div>

//                   {/* Content */}
//                   <h3 className="text-xl font-bold text-foreground mb-3">
//                     {feature.title}
//                   </h3>
//                   <p className="text-muted-foreground leading-relaxed">
//                     {feature.description}
//                   </p>
//                 </div>

//                 {/* Glow Effect */}
//                 <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-xl bg-gradient-to-br from-primary/10 to-accent/10 -z-10" />
//               </div>
//             </motion.div>
//           ))}
//         </div>

//         {/* Bottom CTA */}
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           animate={inView ? { opacity: 1, y: 0 } : {}}
//           transition={{ delay: 0.9 }}
//           className="text-center mt-16"
//         >
//           <div className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-primary/10 to-accent/10 rounded-full border border-primary/20">
//             <motion.div
//               animate={{ rotate: 360 }}
//               transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
//             >
//               <Sparkles className="w-6 h-6 text-primary" />
//             </motion.div>
//             <p className="text-foreground font-medium">
//               Join thousands of professionals networking smarter
//             </p>
//           </div>
//         </motion.div>
//       </div>
//     </section>
//   );
// }



import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link2, Target, Zap, RefreshCw, Sparkles, Smartphone } from 'lucide-react';

const features = [
  { icon: Link2, title: 'Seamless Social Media Integration', description: 'Smart cards link instantly to platforms like LinkedIn, Twitter, Instagram, enabling smooth transitions from in-person meetings to online connections.', gradient: ['#3b82f6', '#06b6d4'] },
  { icon: Target, title: 'Customized Sharing Options', description: 'Choose platforms based on your profession: Creatives → Instagram/Pinterest, Corporate → LinkedIn', gradient: ['#8b5cf6', '#ec4899'] },
  { icon: Zap, title: 'Simplified Connection Process', description: 'One tap replaces searching names or usernames — no more missed connections or spelling errors.', gradient: ['#facc15', '#f97316'] },
  { icon: RefreshCw, title: 'Dynamic Content Delivery', description: 'Share live content such as recent posts, portfolio updates, and achievements in real-time.', gradient: ['#10b981', '#22c55e'] },
  { icon: Sparkles, title: 'Tech-Savvy Professional Image', description: 'Using smart cards shows innovation and forward-thinking professionalism.', gradient: ['#6366f1', '#8b5cf6'] },
  { icon: Smartphone, title: 'Adapting to Digital-First Networking', description: 'Perfect for modern, tech-savvy professionals embracing digital networking trends.', gradient: ['#ec4899', '#f43f5e'] },
];

const SocialMediaSynergy = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section
      ref={ref}
      style={{
        position: 'relative',
        padding: '80px 16px',
        overflow: 'hidden',
        background: 'linear-gradient(to bottom, rgba(139,92,246,0.05), transparent)',
      }}
    >
      {/* Title */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
        style={{ textAlign: 'center', marginBottom: '64px' }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={inView ? { opacity: 1, scale: 1 } : {}}
          transition={{ delay: 0.2 }}
          style={{ display: 'inline-block', marginBottom: '16px' }}
        >
          <div style={{
            padding: '4px 24px',
            borderRadius: '9999px',
            border: '1px solid rgba(139,92,246,0.2)',
            background: 'linear-gradient(to right, rgba(139,92,246,0.1), rgba(236,72,153,0.1))',
          }}>
            <span style={{ fontSize: '0.75rem', fontWeight: '600', textTransform: 'uppercase', color: '#8b5cf6', letterSpacing: '0.05em' }}>
              Building Online Connections
            </span>
          </div>
        </motion.div>

        <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '16px', lineHeight: 1.2 }}>
          Smart Cards &{' '}
          <span style={{ background: 'linear-gradient(to right, #8b5cf6, #ec4899)', WebkitBackgroundClip: 'text', color: 'transparent' }}>
            Social Media Synergy
          </span>
        </h2>
        <p style={{ fontSize: '1.125rem', color: '#888888', maxWidth: '800px', margin: '0 auto' }}>
          Transform how you connect by seamlessly bridging physical and digital networking
        </p>
      </motion.div>

      {/* Feature Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
        gap: '24px',
        maxWidth: isMobile ? '100%' : '1200px',
        margin: isMobile ? '0' : '0 auto'
      }}>
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 40 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.1 + 0.3, duration: 0.6 }}
              whileHover={{ y: -8, scale: 1.02 }}
              style={{
                position: 'relative',
                background: '#fff',
                borderRadius: '24px',
                border: '1px solid #e5e7eb',
                padding: '24px',
                boxShadow: '0 8px 16px rgba(0,0,0,0.05)',
                overflow: 'hidden',
              }}
            >
              {/* Icon */}
              <motion.div
                whileHover={{ scale: 1.1, rotate: 5 }}
                transition={{ type: 'spring', stiffness: 300 }}
                style={{
                  width: '56px',
                  height: '56px',
                  borderRadius: '16px',
                  background: `linear-gradient(to bottom right, ${feature.gradient[0]}, ${feature.gradient[1]})`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '16px',
                  boxShadow: '0 6px 12px rgba(0,0,0,0.1)',
                  color: '#fff',
                }}
              >
                <Icon style={{ width: '100%', height: '100%', color: 'white' }} />
              </motion.div>

              {/* Content */}
              <h3 style={{ fontSize: '1.25rem', fontWeight: '700', marginBottom: '8px' }}>
                {feature.title}
              </h3>
              <p style={{ fontSize: '0.875rem', color: '#888888', lineHeight: 1.5 }}>
                {feature.description}
              </p>
            </motion.div>
          );
        })}
      </div>

      {/* Bottom CTA */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ delay: 0.9 }}
        style={{ textAlign: 'center', marginTop: '64px' }}
      >
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '12px',
          padding: '16px 32px',
          borderRadius: '9999px',
          border: '1px solid rgba(139,92,246,0.2)',
          background: 'linear-gradient(to right, rgba(139,92,246,0.1), rgba(236,72,153,0.1))'
        }}>
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
          >
            <Sparkles style={{ width: '24px', height: '24px', color: '#8b5cf6' }} />
          </motion.div>
          <p style={{ fontWeight: '500', color: '#111' }}>
            Join thousands of professionals networking smarter
          </p>
        </div>
      </motion.div>
    </section>
  );
};

export default SocialMediaSynergy;
